module.exports = __webpack_public_path__ + "img/logo-b-vertical.bbad6968.png";